import BlogPost from "./BlogPost.js"

const BlogPage = ({ blogPosts }) => {
    return (
        <div className="container container-fluid pt-4">
            {blogPosts.map((blogPost) =>
                <BlogPost key={blogPost.key} title={blogPost.title} subtitle={blogPost.subtitle} body={blogPost.body} images={blogPost.images} />
            )}
        </div>
    )
}

export default BlogPage
